import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { baseUrl } from "../../../services/config";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

export default function ParentLogin() {
  const history = useHistory();
  const [cnic, setCnic] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!cnic.trim() || !password.trim()) {
      setError("CNIC and password are required.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${baseUrl}/parent/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ cnic: cnic.trim(), password }),
      });
      const response = await res.json();
      if (res.ok && response.payload) {
        const { token, user, children } = response.payload;
        localStorage.setItem("parentToken", token);
        localStorage.setItem("parentUser", JSON.stringify(user));
        localStorage.setItem("parentChildren", JSON.stringify(children || []));
        history.push("/parent/dashboard");
      } else {
        setError(response.message || "Invalid CNIC or password.");
      }
    } catch (err) {
      console.error("Parent login error:", err);
      setError("Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f1f5f9",
      }}
    >
      <div
        style={{
          width: 420,
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 20px 60px rgba(15,23,42,0.12)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#121291",
            padding: "32px 40px 28px",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <LockOutlinedIcon style={{ fontSize: 28, color: "#fff" }} />
          </div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Parent Portal
          </h2>
          <p style={{ margin: "6px 0 0", fontSize: 13, opacity: 0.75 }}>
            Sign in with your CNIC to continue
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ padding: "32px 40px 36px" }}>
          {error && (
            <div
              style={{
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: "10px 14px",
                color: "#dc2626",
                fontSize: 13,
                marginBottom: 20,
              }}
            >
              {error}
            </div>
          )}

          <div style={{ marginBottom: 18 }}>
            <label
              style={{
                display: "block",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                marginBottom: 6,
              }}
            >
              CNIC
            </label>
            <input
              type="text"
              value={cnic}
              onChange={(e) => setCnic(e.target.value)}
              placeholder="e.g. 35201-1234567-1"
              style={{
                width: "100%",
                border: "1.5px solid #e2e8f0",
                borderRadius: 10,
                padding: "13px 16px",
                fontSize: 15,
                color: "#0f172a",
                background: "#f8fafc",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                display: "block",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                marginBottom: 6,
              }}
            >
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                style={{
                  width: "100%",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: 10,
                  padding: "13px 44px 13px 16px",
                  fontSize: 15,
                  color: "#0f172a",
                  background: "#f8fafc",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#94a3b8",
                  fontSize: 13,
                  fontWeight: 600,
                  userSelect: "none",
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              background: loading ? "#9ca3af" : "#121291",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "14px",
              fontSize: 15,
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {loading && (
              <span
                className="spinner-border spinner-border-sm"
                style={{ width: 16, height: 16 }}
              />
            )}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
